export enum ZoomPolicy {
  alwaysShowAllRelevantNodes = 'alwaysShowAllRelevantNodes',
  autoZoomDisabled = 'autoZoomDisabled',
  autoZoomEnabled = 'autoZoomEnabled',
}

export enum NodeSelectionMode {
  anyNode = 'anyNode',
  directChildren = 'directChildren'
}

export class TreeNavigationConfiguration {
  zoomPolicy: ZoomPolicy = ZoomPolicy.autoZoomDisabled;
  numberOfLastExecutedNodesToShow: number = 2;
  nodeSelectionMode: NodeSelectionMode.anyNode;
}
